import { URLS } from "../../Utilities/Maps";

export const NAV_LINKS = {
  accountSettings: "/accountsettings",
  autoclip: URLS.AUTOCAPTURE,
  company: "/about",
  competitions: "/competitions",
  dashboard: URLS.DASHBOARD,
  following: "/profile?view=Following",
  library: "/library",
  login: "/login",
  matchHistory: "/match-history",
  montages: "/montages/create",
  partners: "https://developer.allstar.gg/auth/allstar",
  profile: "/u",
  root: "/",
  studio: "/studio",
  support: "https://help.allstar.gg/hc/en-us/requests/new",
  teams: "/teams",
  terms: "/legal/terms-of-use",
  upgrade: "/upgrade",
};

export const isActive = (urls: string[]) => {
  return (
    urls.includes(`/${window.location.pathname.split("/")[1]}`) ||
    urls.includes(window.location.pathname)
  );
};
